import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  const goToCookiePolicy = () => {
    navigate('/politica-cookies');
  };

  const goToPrivacyPolicy = () => {
    navigate('/politica-privacidade');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-teal-600 shadow-2xl animate-slide-up">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-start gap-4 flex-1">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
              <i className="ri-cookie-line text-2xl text-teal-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Este website utiliza cookies 🍪
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Utilizamos cookies para melhorar a sua experiência, analisar o tráfego do site e personalizar conteúdo. 
                Ao clicar em "Aceitar", concorda com a utilização de cookies.{' '}
                <button
                  onClick={goToCookiePolicy}
                  className="text-teal-600 hover:text-teal-700 font-medium underline cursor-pointer"
                >
                  Política de Cookies
                </button>
                {' | '}
                <button
                  onClick={goToPrivacyPolicy}
                  className="text-teal-600 hover:text-teal-700 font-medium underline cursor-pointer"
                >
                  Política de Privacidade
                </button>
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={rejectCookies}
              className="px-6 py-3 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Recusar
            </button>
            <button
              onClick={acceptCookies}
              className="px-6 py-3 text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Aceitar Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}